
const chords = [
// Step 1
{
  formula: [1, 3, 5],
  key: 1,
  name: '@',
  type: 'Normal Triads'
}, {
  formula: [1, 3, 5, 6],
  key: 1,
  name: '@6',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 7],
  key: 1,
  name: '@maj7',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 6, 2],
  key: 1,
  name: '@6/9',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 2],
  key: 1,
  name: '@maj9',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 6],
  key: 1,
  name: '@maj13',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 2, 5],
  key: 1,
  name: '@sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5],
  key: 1,
  name: '@sus4',
  type: 'Suspended Chords'
}, {
  formula: [1, 2, 5, 7],
  key: 1,
  name: '@7sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5, 7],
  key: 1,
  name: '@7sus4',
  type: 'Suspended Chords'
},
// Step 2
{
  formula: [1, 3, 5],
  key: 2,
  name: '@m',
  type: 'Normal Triads'
}, {
  formula: [1, 3, 5, 6],
  key: 2,
  name: '@m6',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 7],
  key: 2,
  name: '@m7',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 7, 2],
  key: 2,
  name: '@m9',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 4],
  key: 2,
  name: '@m11',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 6],
  key: 2,
  name: '@m13',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 2, 5],
  key: 2,
  name: '@sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5],
  key: 2,
  name: '@sus4',
  type: 'Suspended Chords'
}, {
  formula: [1, 2, 5, 7],
  key: 2,
  name: '@7sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5, 7],
  key: 2,
  name: '@7sus4',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5, 7, 2],
  key: 2,
  name: '@9sus4',
  type: 'Suspended Chords'
},
// Step 3
{
  formula: [1, 3, 5],
  key: 3,
  name: '@m',
  type: 'Normal Triads'
}, {
  formula: [1, 3, 5, 7],
  key: 3,
  name: '@m7',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 7, 4],
  key: 3,
  name: '@m11',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 4, 5],
  key: 3,
  name: '@sus4',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5, 7],
  key: 3,
  name: '@7sus4',
  type: 'Suspended Chords'
},
// Step 4
{
  formula: [1, 3, 5],
  key: 4,
  name: '@',
  type: 'Normal Triads'
}, {
  formula: [1, 3, 5, 6],
  key: 4,
  name: '@6',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 7],
  key: 4,
  name: '@maj7',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 6, 2],
  key: 4,
  name: '@6/9',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 2],
  key: 4,
  name: '@maj9',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 6],
  key: 4,
  name: '@maj13',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 2, 5],
  key: 4,
  name: '@sus2',
  type: 'Suspended Chords'
},
// Step 5
{
  formula: [1, 3, 5],
  key: 5,
  name: '@',
  type: 'Normal Triads'
}, {
  formula: [1, 3, 5, 6],
  key: 5,
  name: '@6',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 7],
  key: 5,
  name: '@7',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 6, 2],
  key: 5,
  name: '@6/9',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 2],
  key: 5,
  name: '@maj9',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 6],
  key: 5,
  name: '@maj13',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 2, 5],
  key: 5,
  name: '@sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5],
  key: 5,
  name: '@sus4',
  type: 'Suspended Chords'
}, {
  formula: [1, 2, 5, 7],
  key: 5,
  name: '@7sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5, 7],
  key: 5,
  name: '@7sus4',
  type: 'Suspended Chords'
}, {
  formula: [1, 2, 5, 7, 2],
  key: 5,
  name: '@9sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5, 7, 2],
  key: 5,
  name: '@9sus4',
  type: 'Suspended Chords'
},
// Step 6
{
  formula: [1, 3, 5],
  key: 6,
  name: '@m',
  type: 'Normal Triads'
}, {
  formula: [1, 3, 5, 7],
  key: 6,
  name: '@m7',
  type: '4 Notes Chords'
}, {
  formula: [1, 3, 5, 7, 2],
  key: 6,
  name: '@m9',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 3, 5, 7, 4],
  key: 6,
  name: '@m11',
  type: '5 and 6 Note Chords'
}, {
  formula: [1, 2, 5],
  key: 6,
  name: '@sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5],
  key: 6,
  name: '@sus4',
  type: 'Suspended Chords'
}, {
  formula: [1, 2, 5, 7],
  key: 6,
  name: '@7sus2',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5, 7],
  key: 6,
  name: '@7sus4',
  type: 'Suspended Chords'
}, {
  formula: [1, 4, 5, 7, 2],
  key: 6,
  name: '@9sus4',
  type: 'Suspended Chords'
},
// Step 7
{
  formula: [1, 3, 5],
  key: 7,
  name: '@dim',
  type: 'Normal Triads'
}, {
  formula: [1, 3, 5, 7],
  key: 7,
  name: '@m7b5',
  type: '4 Notes Chords'
}]

export default chords



// WEBPACK FOOTER //
// ./src/constants/chords.js